<template>
  <div id="app">
    <div>
      <div
        v-if="$route.path != '/reports' && $route.path != '/'"
        class="d-flex bgNavbarHeader justify-content-md-normal"
        :style="['Movie Summary Report', 'Movie Show Wise Report', 'Week Wise Movie History Report', 'Summary Report', 'Occupancy Report'].includes($route.meta.subName) ? 'background-color: #1c2b46 !important;' : ''"
      >
        <p
          class="backBtnContainer ml-2 ml-md-1 mt-1"
          @click="$router.go(-1)"
          v-if="$route.path !== '/'"
        >
          <img
            src="@/assets/img/icons/back-arrow.svg"
            alt=""
            class="w-100 h-100"
          />
        </p>
        <div v-else class="pl-2">
          <img
            v-b-toggle.sidebar-1
            alt="Menu"
            class="ham_icon"
            src="@/assets/img/hamburger-menu.png"
          />
          <b-sidebar id="sidebar-1" title="" shadow>
            <div class="px-3 py-2 sub_menu">
              <p @click="homePage()"> Home </p>
              <p
                @click="toggleAnalyticsMenu()"
                :style="showAnalyticsMenu ? 'color:red' : ''"
              >
                Analytics Reports
              </p>
              <div v-if="showAnalyticsMenu" class="analytics-submenu pl-3">
                <p
                  v-for="item in navBarItems"
                  :key="item.id"
                  class="sidebar-link"
                  @click="navigate(item.url)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </b-sidebar>
        </div>
       
        <p
          class="text-center my-0 module_name_container mx-auto mt-1"
          :class="[
            ['Movie Summary Report', 'Movie Show Wise Report', 'Week Wise Movie History Report', 'Summary Report', 'Occupancy Report'].includes($route.meta.subName) ? '' : 'text-light',
            $route.meta.subName === 'Week Wise Movie History Report' ? 'week-wise-title' : ''
          ]"
          :style="['Movie Summary Report', 'Movie Show Wise Report', 'Week Wise Movie History Report', 'Summary Report', 'Occupancy Report'].includes($route.meta.subName) ? 'color: #f3c300 !important;' : ''"
          >{{ $route.meta.subName }}</p
        >

        <img style="margin-right: 40px; height: 25px;" src="@/assets/img/icons/home.svg" alt=""
        @click="homePage()"
        >
      </div>
      <router-view />
    </div>
    <!-- <div v-else>
      <connectionLost />
    </div> -->
  </div>
</template>

<script>
  import Loader from "@/components/Partials/loader.vue";
  import connectionLost from "@/components/Partials/connection-lost.vue";
  import Modal from "@/components/Partials/globalModal.vue";
  import navLists from "@/helper/navLists";
  import MasterService from "@/services/MasterService";
  export default {
    name: "App",
    components: {
      Loader,
      Modal,
      connectionLost,
    },
    data() {
      return {
        onLine: navigator.onLine,
        showAnalyticsMenu: false,
      };
    },
    beforeRouteEnter(to, from, next) {
      // return store.fetchSpecial(to.params.slug).then(next)
      next();
    },
    beforeMount() {
      
    },
    beforeDestroy() {
      window.removeEventListener("online", this.updateOnlineStatus);
      window.removeEventListener("offline", this.updateOnlineStatus);
    },
    mounted() {
      window.addEventListener("online", this.updateOnlineStatus);
      window.addEventListener("offline", this.updateOnlineStatus);
      this.fetchGlobalOptions()
 
    },
    computed: {
      navBarItems() {
        return navLists;
      },
      currentNavName() {
        let navName = "";
        let navIndex = this.navBarItems.findIndex((navObj) => {
          return navObj.url == this.$route.path;
        });
        if (navIndex >= 0) {
          navName = this.navBarItems[navIndex].name;
        } else {
          return;
        }
        return navName;
      },
    },
    methods: {
      homePage() {
        this.$router.push("/reports");
      },
      toggleAnalyticsMenu() {
        this.showAnalyticsMenu = !this.showAnalyticsMenu;
      },
      navigate(path) {
        this.showAnalyticsMenu = false;
        this.$router.push(path);
        this.$root.$emit("bv::hide::sidebar", "sidebar-1");
      },
      updateOnlineStatus(e) {
        const { type } = e;
        this.onLine = type === "online";
      },
      fetchGlobalOptions: () => {
    MasterService.GetGlobalOptions().then((response) => {
      const { data } = response;
      console.log("Client_name", data)
      if (data && data.status && data.Records.length > 0) {
         const CLIENT_SETUP_NAME = data.Records.find(
          (go) => go.go_key == "CLIENT_SETUP_NAME"
        );
       console.log("CLIENT_SETUP_NAME",CLIENT_SETUP_NAME)
       localStorage.setItem("setUpName", JSON.stringify(CLIENT_SETUP_NAME.go_value));

      } else {
        console.log("Erro in fetching global options");
      }
    });
  },
    },
  };
</script>
<style>
  .sub_menu p {
    padding-bottom: 5px;
    border-bottom: 1px solid #000;
    font-size: 20px;
  }
  .analytics-submenu {
    margin-top: 12px;
  }
  .sidebar-link {
    cursor: pointer;
    color: #0f172a;
    margin: 6px 0;
    font-size: 16px;
  }
  .sidebar-link:hover {
    color: #1d4ed8;
  }
  .ham_icon {
    width: 35px;
  }
  
  /* Global Vuejs-datepicker Theme Overrides */
  .vdp-datepicker__calendar {
    border-radius: 8px !important;
    border: none !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
    overflow: hidden !important;
  }
  
  .vdp-datepicker__calendar header {
    background-color: #0c1a32 !important; /* Dark blue header */
    color: white !important;
    font-weight: 600 !important;
  }
  
  .vdp-datepicker__calendar header span {
    background-color: #0c1a32 !important;
    color: white !important;
  }
  
  .vdp-datepicker__calendar header .prev:after {
    border-right-color: white !important;
  }
  
  .vdp-datepicker__calendar header .next:after {
    border-left-color: white !important;
  }
  
  .vdp-datepicker__calendar header span:hover {
    background-color: #1c2b46 !important;
  }
  
  .vdp-datepicker__calendar .cell.selected,
  .add-datepicker .vdp-datepicker__calendar .cell.selected,
  .add-datepicker .day.selected,
  .add-datepicker .month.selected,
  .add-datepicker .year.selected {
    background-color: #f3c300 !important; /* Gold/yellow selected state */
    color: white !important;
    border: none !important;
  }
  
  .vdp-datepicker__calendar .cell.day,
  .vdp-datepicker__calendar .cell.month,
  .vdp-datepicker__calendar .cell.year {
    border-radius: 50% !important;
    height: 34px !important;
    line-height: 34px !important;
    margin: 1px 0 !important;
  }
  
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, 
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, 
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover,
  .add-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
  .add-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
  .add-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
    border-color: #f3c300 !important;
  }
  
  /* Mobile Global Positioning */
  @media (max-width: 767px) {
    .vdp-datepicker__calendar {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      z-index: 9999 !important;
      max-width: 260px !important; /* Smaller size on mobile */
      width: 260px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue